// TAB: It's important to import this before any Component definitions happen
import './utilities/vueClassComponentHooks';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont';

// TAB: Uncomment the following to use the mock backend
// import { setUpMockBackend } from './utilities/mockBackend';
// setUpMockBackend();

Vue.config.productionTip = false;

store.dispatch('authenticationModule/checkLocalStorageForUser');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
